import type { SVGProps } from 'react';
const SvgHourglass = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" height={12} viewBox="0 0 12 12" width={12} xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#hourglass_svg__a)">
      <path
        d="M4.5 9.25h3M3.3 1h5.4c.28 0 .42 0 .527.054a.5.5 0 0 1 .218.219c.055.107.055.247.055.527v1.037c0 .245 0 .367-.028.482a1 1 0 0 1-.12.29c-.061.1-.148.187-.32.36L7.565 5.434c-.198.198-.297.297-.334.411a.5.5 0 0 0 0 .31c.037.114.136.213.334.41L9.03 8.032c.173.173.26.26.322.36a1 1 0 0 1 .12.29c.027.115.027.237.027.482V10.2c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.218C9.12 11 8.98 11 8.7 11H3.3c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.219-.218C2.5 10.62 2.5 10.48 2.5 10.2V9.163c0-.245 0-.367.028-.482a1 1 0 0 1 .12-.29c.061-.1.148-.187.32-.36l1.466-1.465c.198-.198.297-.297.334-.411a.5.5 0 0 0 0-.31c-.037-.114-.136-.213-.334-.41L2.97 3.968c-.173-.173-.26-.26-.322-.36a1 1 0 0 1-.12-.29C2.5 3.204 2.5 3.082 2.5 2.837V1.8c0-.28 0-.42.054-.527a.5.5 0 0 1 .219-.218C2.88 1 3.02 1 3.3 1"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </g>
    <defs>
      <clipPath id="hourglass_svg__a">
        <path d="M0 0h12v12H0z" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHourglass;
export { SvgHourglass };
